// extracted by mini-css-extract-plugin
module.exports = {"container":"Medical_container__1KKCF","create":"Medical_create__MI9IX"};